import { actions } from "../../actions/action-list";
import initialState from "./initialState";

const BreakDownCollections = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.FETCH_BREAK_DOWN_COLLECTION
      .FETCH_DATE_DUE_BREAK_DOWN_COLLECTION:
      return { ...state, dateDueBreakDown: action.value };
    default:
      return state;
  }
};

export default BreakDownCollections;
